import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { LanguageContext } from '../LanguageContext';
import BlogSection from '../components/BlogSection';
import hero4 from '../img/hero4 (1).png';

function Blog() {
  const { language } = useContext(LanguageContext);

  const content = {
    fr: {
      title: "NOTRE BLOG",
      subtitle: "Découvrez nos derniers articles et conseils pour préparer votre voyage spirituel",
    },
    ar: {
      title: "مدونتنا",
      subtitle: "اكتشف أحدث مقالاتنا ونصائحنا للتحضير لرحلتك الروحية",

    }
  };

  const textAnimation = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { 
        duration: 0.8, 
        ease: 'easeOut' 
      } 
    },
  };

  return (
    <div className="bg-gradient-to-r from-blue-50 via-green-100 to-blue-50" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <section className="relative h-[500px] overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="absolute inset-0 h-full"
        >
          <img
            className="w-full h-full object-cover"
            src={hero4}
            alt={language === 'fr' ? "Blog Background" : "خلفية المدونة"}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-80"></div>
        </motion.div>
        
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textAnimation}
          className="relative h-full flex flex-col items-center justify-center px-4 text-center"
        >
          <h1 className="text-white text-5xl md:text-6xl font-extrabold mb-4 tracking-wide">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-300 to-green-500">
              {content[language].title}
            </span>
          </h1>
          <div className="w-32 h-2 bg-green-400 rounded-full mb-6"></div>
          <p className="text-gray-200 text-xl max-w-2xl">
            {content[language].subtitle}
          </p>
        </motion.div>
      </section>

      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={textAnimation}
          className="mb-16"
        >
          <h2 className="text-4xl font-bold text-center mb-12 relative">
            <span className="relative z-10 px-4 bg-gradient-to-r from-green-500 to-green-600 bg-clip-text text-transparent">
              {content[language].featuredTitle}
            </span>
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-green-400 to-blue-400 rounded-full"></span>
          </h2>
          
          <BlogSection 
            language={language} 
            featured 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          />
        </motion.div>

        
      </div>
    </div>
  );
}

export default Blog;